import Fetch, { V1, V2, V4 } from 'Util/fetcher';
import Cookies from 'js-cookie';
import Compressor from 'compressorjs';

import { authStorage, kycStorage , encrypt } from '@ajaibid/utils';
import { AES_ENCRYPTION_SECRET_KEY, COOKIE_KEY , DEFAULT_GET_RESPONSE } from '@config/constanta';

const QUALITY = 0.1;
const CONVERT_SIZE = 5000000;

const CompressImg = (file) =>
  new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      quality: QUALITY,
      convertSize: CONVERT_SIZE,
      success: resolve,
      error: reject,
    });
  });

const UPDATED_NIK_EDUCATION = 'UPDATE_NIK_EDUCATION';
const ON_REQUEST_DUKCAPIL_COMPLETED = 'ON_REQUEST_DUKCAPIL_COMPLETED';
const ON_REQUEST_DUKCAPIL_LIMIT = 'ON_REQUEST_DUKCAPIL_LIMIT';
const ON_REQUEST_DUKCAPIL_FAILURE = 'ON_REQUEST_DUKCAPIL_FAILURE';
const ON_RETRY_DUKCAPIL_FAILURE = 'ON_RETRY_DUKCAPIL_FAILURE';
const FILL_MANUALLY_FORM = 'FILL_MANUALLY_FORM';
const FILL_AUTOMATE_FORM = 'FILL_AUTOMATE_FORM';
const COLLECT_DUKCAPIL_DATA = 'COLLECT_DUKCAPIL_DATA';
const NEXT_QUESTIONS = 'NEXT_QUESTIONS';
const NEXT_EDD_QUESTIONS = 'NEXT_EDD_QUESTIONS';
const GET_BANK_LIST = 'GET_BANK_LIST';
const ON_SELECTED_BANK = 'ON_SELECTED_BANK';
const ON_COLLECTED_BANK = 'ON_COLLECTED_BANK';
const ON_COLLECTED_EXPERIENCE = 'ON_COLLECTED_EXPERIENCE';
const ON_SET_DOB = 'ON_SET_DOB';
const ON_REQUEST_DUKCAPIL = 'ON_REQUEST_DUKCAPIL';
const ON_REQUEST_DUKCAPIL_ERR = 'ON_REQUEST_DUKCAPIL_ERR';
const ON_REQUEST_DUKCAPIL_SUCCESS = 'ON_REQUEST_DUKCAPIL_SUCCESS';
const ON_SELECTED_CITY = 'ON_SELECTED_CITY';
const ON_SELECTED_PLACE_BIRTH = 'ON_SELECTED_PLACE_BIRTH';
const ON_COLLECTED_OFFICE_INFORMATION = 'ON_COLLECTED_OFFICE_INFORMATION';
const ON_COLLECTED_VIDEO_VERIFICATION = 'ON_COLLECTED_VIDEO_VERIFICATION';
const ON_COLLECTED_SIGN = 'ON_COLLECTED_SIGN';
const ON_COLLECTED_ID_CARD = 'ON_COLLECTED_ID_CARD';
const ON_COLLECTED_SIGNATURE_IMG = 'ON_COLLECTED_SIGNATURE_IMG';
const ON_DO_REQUEST_CITY = 'ON_DO_REQUEST_CITY';
const ON_DO_REQUEST_CITY_FAILURE = 'ON_DO_REQUEST_CITY_FAILURE';
const ON_DO_REQUEST_CITY_SUCCESS = 'ON_DO_REQUEST_CITY_SUCCESS';
const ON_COLLECTED_EDD_INITIAL = 'ON_COLLECTED_EDD_INITIAL';
const ON_COLLECTED_EDD_JOB_INCOME = 'ON_COLLECTED_EDD_JOB_INCOME';
const ON_COLLECTED_BENEFICIAL_OWNER = 'ON_COLLECTED_BENEFICIAL_OWNER';


function onRequestCity() {
  return {
    type: ON_DO_REQUEST_CITY,
  };
}

function onDoRequestCityFailure(payload) {
  return {
    type: ON_DO_REQUEST_CITY_FAILURE,
    payload,
  };
}

function onDoRequestCitySuccess(payload) {
  return {
    type: ON_DO_REQUEST_CITY_SUCCESS,
    payload,
  };
}

export const onDoRequestCity = () => (dispatch) => {
  dispatch(onRequestCity());
  Fetch.get(`${V1}users/me/city-code/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onDoRequestCitySuccess(resp.json.kota));
      } else {
        dispatch(onDoRequestCityFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onDoRequestCityFailure(error.message));
    });
};

function onDoRequestDukcapil() {
  return {
    type: ON_REQUEST_DUKCAPIL,
  };
}

function onDoRequestDukcapilErr(payload) {
  return {
    type: ON_REQUEST_DUKCAPIL_ERR,
    payload,
  };
}

function onDoRequestDukcapilSuccess(payload) {
  return {
    type: ON_REQUEST_DUKCAPIL_SUCCESS,
    payload,
  };
}

export function onDoSetDob(payload) {
  return {
    type: ON_SET_DOB,
    payload,
  };
}

export function onDoBankSelected(payload) {
  return {
    type: ON_SELECTED_BANK,
    payload,
  };
}

function onDoSetBank(payload) {
  return {
    type: GET_BANK_LIST,
    payload,
  };
}

export const onDoGetBankList = () => (dispatch) => {
  Fetch.get(`${V1}bank-account/banks`).then((resp) => {
    if (resp.ok && resp.json.results) {
      dispatch(onDoSetBank(resp.json.results));
    }
  });
};

export function onUpdateNikEducation(payload) {
  return {
    type: UPDATED_NIK_EDUCATION,
    payload,
  };
}

export function onRetryDukcapilFailure() {
  return {
    type: ON_RETRY_DUKCAPIL_FAILURE,
  };
}

export function onManualForm() {
  return {
    type: FILL_MANUALLY_FORM,
  };
}

export function onAutomateForm() {
  return {
    type: FILL_AUTOMATE_FORM,
  };
}

function onDukcapilError(payload) {
  return {
    type: ON_REQUEST_DUKCAPIL_FAILURE,
    payload,
  };
}

function onDukcapilLimit() {
  return {
    type: ON_REQUEST_DUKCAPIL_LIMIT,
  };
}

export function onDukcapilData(payload) {
  return {
    type: ON_REQUEST_DUKCAPIL_COMPLETED,
    payload,
  };
}

export const onRequestDukcapilNik = (nik) => (dispatch) => {
  Fetch.post(`${V2}users/me/nik/validate/`, { nik })
    .then((resp) => {
      if (resp.json.valid) {
        const dateData = resp.json.data.dob.split('-');
        const dateObject = new Date(dateData[0], dateData[1] - 1, dateData[2]);
        dispatch(onDoSetDob(dateObject));
        dispatch(onDukcapilData(resp.json.data));
      } else {
        dispatch(onDukcapilError(resp.json));
      }
    })
    .catch(() => {
      dispatch(onDukcapilLimit());
    });
};

export function onCollectedData(payload) {
  return {
    type: ON_COLLECTED_BANK,
    payload,
  };
}

export function onCollectDukcapilData(payload) {
  return {
    type: COLLECT_DUKCAPIL_DATA,
    payload,
  };
}

export function onNextQuestions(payload) {
  return {
    type: NEXT_QUESTIONS,
    payload,
  };
}

export function onNextEddQuestions(payload) {
  return {
    type: NEXT_EDD_QUESTIONS,
    payload
  };
}

export function onCollectedExperience(payload) {
  return {
    type: ON_COLLECTED_EXPERIENCE,
    payload,
  };
}

export function onCollectedOfficeInformation(payload) {
  return {
    type: ON_COLLECTED_OFFICE_INFORMATION,
    payload,
  };
}

export function onCollectedVideoVerification(payload) {
  return {
    type: ON_COLLECTED_VIDEO_VERIFICATION,
    payload,
  };
}

export function onCollectedIdCard(payload) {
  return {
    type: ON_COLLECTED_ID_CARD,
    payload,
  };
}

export function onCollectedSignatureImg(payload) {
  return {
    type: ON_COLLECTED_SIGNATURE_IMG,
    payload,
  };
}

export function onCollectedSign(payload) {
  return {
    type: ON_COLLECTED_SIGN,
    payload,
  };
}

export function onCollectedEddInitial(payload) {
  return {
    type: ON_COLLECTED_EDD_INITIAL,
    payload
  };
}

export function onCollectedEddJobIncome(payload) {
  return {
    type: ON_COLLECTED_EDD_JOB_INCOME,
    payload
  };
}

export function onCollectedBeneficialOwner(payload) {
  return {
    type: ON_COLLECTED_BENEFICIAL_OWNER,
    payload
  };
}

export const onSubmittedPayload = (payload) => (dispatch) => {
    CompressImg(payload.idCard[0]).then((response) => {
      const reader = new FileReader();
      reader.readAsDataURL(response);
      reader.onloadend = () => {
        const pay = {
          account_number: payload.accountNumber,
          account_owner_name: payload.accountName,
          annual_income: parseInt(payload.annual_income, 10),
          bank_swift_code: payload.bank_swift_code,
          coin_opening: payload.coinOpening,
          dob: payload.dob,
          education_level: payload.education,
          first_name:
            typeof payload.first_name !== 'undefined'
              ? payload.first_name
              : payload.name,
          id_number:
            typeof payload.id_number !== 'undefined'
              ? payload.id_number
              : payload.nik,
          investing_knowledge: parseInt(payload.investing_knowledge, 10),
          investment_objective: parseInt(payload.investment_objective, 10),
          ktp_address: payload.address,
          ktp_photo: reader.result.replace('data:image/jpeg;base64,', ''),
          source_income: parseInt(payload.source_income, 10),
          is_dukcapil: payload.automateForm ? 1 : 0,
          occupation:
            payload.occupation && parseInt(payload.occupation, 10) !== 0
              ? parseInt(payload.occupation, 10)
              : 8,
          religion: payload.religion,
          marital_status: payload.marital_status,
          risk_tolerance: payload.risk_tolerance
            ? payload.risk_tolerance
            : null,
          company_name: payload.company_name,
          office_address: payload.office_address,
          office_rt: parseInt(payload.office_rt, 10)
            ? parseInt(payload.office_rt, 10)
            : 2,
          office_rw: parseInt(payload.office_rw, 10)
            ? parseInt(payload.office_rw, 10)
            : 2,
          office_zipcode: payload.office_zipcode,
          office_telp: payload.office_telp,
          mother_maiden_name:
            typeof payload.mother_maiden_name !== 'undefined'
              ? payload.mother_maiden_name
              : payload.motherName,
          section: kycStorage.get('kycKategory') ? kycStorage.get('kycKategory') : 3,
          economy_sector: payload.economy_sector,
          selected_economy_sector: payload.selected_economy_sector,
          video: payload.rescVideo ? payload.rescVideo : '',
          place_birth_code: payload.selectedPlaceBirth
            ? payload.selectedPlaceBirth.value
            : null,
          place_birth: payload.selectedPlaceBirth
            ? payload.selectedPlaceBirth.text
            : null,
          npwp_number: payload.npwp_number
        };
        if (pay.npwp_number === null) {
          delete pay.npwp_number;
        }

      if (payload.id_bank === 3 && kycStorage.get('config') === '1') {
        if (kycStorage.get('config') === '1' || kycStorage.get('permataRdn')) {
          pay.my_signature = payload.rescSign.replace('data:image/png;base64,', '');
        } else {
          pay.my_signature = payload.imgSignature.replace('data:image/png;base64,', '');
        }
        pay.rdn_type = 'BCA';
      } else {
        pay.my_signature = payload.rescSign.replace('data:image/png;base64,', '');
      }

        if (payload.economy_sector === 11 || payload.economy_sector === '11') {
          pay.economy_sector_other = payload.economy_sector_other || payload.selected_economy_sector;
        }

      if (payload.manualForm) {
        pay.zip = payload.zipCode;
        pay.ktp_city_code = payload.selectedCity.value;
      }

      if (payload.automateForm) {
        pay.kecamatan = payload.kecamatan;
        pay.kelurahan = payload.kelurahan;
        pay.ktp_city_code = payload.ktp_city_code;
      }

      dispatch(onDoRequestDukcapil());
      Fetch.post(`${V4}users/me/kyc/`, pay, false, false)
        .then((resp) => {
          if (resp.ok) {
            dispatch(onDoRequestDukcapilSuccess(resp.json));
            kycStorage.set('instantKycSubmitted', true);
            const pinToken = Cookies.get(COOKIE_KEY.pin_token);
            if (pinToken) {
              const ciphertext = encrypt(pinToken, AES_ENCRYPTION_SECRET_KEY);
              authStorage.set('xyz', ciphertext);
            }
            kycStorage.remove('haveNpwp');
            kycStorage.remove('kycKategory');
          } else {
            const objectKeys = Object.keys(resp.json);
            dispatch(onDoRequestDukcapilErr(resp.json[objectKeys[0]][0]));
          }
        })
        .catch((err) => {
          dispatch(onDoRequestDukcapilErr(err.message));
        });
    };

    reader.onerror = () => {
      reader.abort();
    };
  });
};

export function onDoSelectedCity(payload) {
  return {
    type: ON_SELECTED_CITY,
    payload,
  };
}

export function onDoSelectedPlaceBirth(payload) {
  return {
    type: ON_SELECTED_PLACE_BIRTH,
    payload,
  };
}

const ON_REQUEST_VALIDATE_BANK_ACCOUNT = 'ON_REQUEST_VALIDATE_BANK_ACCOUNT';
const ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS = 'ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS';
const ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE = 'ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE';

function onRequesValidateBankAccount() {
  return {
    type: ON_REQUEST_VALIDATE_BANK_ACCOUNT,
  };
}

function onRequesValidateBankAccountSuccess(payload) {
  return {
    type: ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS,
    payload,
  };
}

function onRequesValidateBankAccountFailure(payload) {
  return {
    type: ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE,
    payload,
  };
}

export const onDoRequesValidateBankAccount = (payload) => (dispatch) => {
  dispatch(onRequesValidateBankAccount());
  Fetch.get(`${V1}stock/verify-bank/${payload.accNumber}/${payload.accName}/CENAIDJA`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequesValidateBankAccountSuccess(resp.json));
      } else {
        dispatch(onRequesValidateBankAccountFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequesValidateBankAccountFailure(error.message));
    });
};

// KYC DUKCAPIL VERIFY
const ON_REQUEST_VERIFY_DUKCAPIL = 'ON_REQUEST_VERIFY_DUKCAPIL';
const ON_REQUEST_VERIFY_DUKCAPIL_SUCCESS = 'ON_REQUEST_VERIFY_DUKCAPIL_SUCCESS';
const ON_REQUEST_VERIFY_DUKCAPIL_FAILURE = 'ON_REQUEST_VERIFY_DUKCAPIL_FAILURE';

function onRequestVerifyDukcapil() {
  return {
    type: ON_REQUEST_VERIFY_DUKCAPIL,
  };
}

function onRequestVerifyDukcapilSuccess(payload) {
  return {
    type: ON_REQUEST_VERIFY_DUKCAPIL_SUCCESS,
    payload,
  };
}

function onRequestVerifyDukcapilFailure(payload) {
  return {
    type: ON_REQUEST_VERIFY_DUKCAPIL_FAILURE,
    payload,
  };
}

export const onDoRequestVerifyDukcapil = (payload) => (dispatch) => {
  dispatch(onRequestVerifyDukcapil());
  Fetch.post(`${V1}dukcapil/verify`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestVerifyDukcapilSuccess(resp));
      } else {
        dispatch(onRequestVerifyDukcapilFailure(resp.json));
      }
    })
    .catch((error) => {
      const errMessage = { ...DEFAULT_GET_RESPONSE, err_message: error.message };      
      dispatch(onRequestVerifyDukcapilFailure(errMessage));
    });
};

const INITIAL_STATE = {
  nik: null,
  education: null,
  occupation: null,
  maxScreen: 7,
  dukcapilData: null,
  isLimitDukcapil: false,
  isFailureDukcapil: false,
  manualForm: false,
  automateForm: false,
  collectData: null,
  formVerifyDukcapil: null,
  isVerifyDukcapilLoading: false,
  isVerifyDukcapilFailure: null,
  activeScreen: 1,
  activeScreenEdd: 0,
  selectedBank: null,
  collectDataBank: null,
  collectedExperience: null,
  collectedOfficeInformation: null,
  collectedVideoVerification: null,
  onRequest: false,
  dob: null,
  isRequestDukcapilResponse: null,
  isRequestDukcapil: false,
  isErrDukcapilError: null,
  coinOpening: false,
  selectedCity: null,
  selectedPlaceBirth: null,
  rescVideo: null,
  sign: null,
  idCard: null,
  cityLoader: false,
  cityData: null,
  cityError: null,
  imgSignature: null,
  validateBankAcc: null,
  validateBankAccSuccess: null,
  validateBankAccError: null,
  collectedEddInitial: null,
  beneficialOwner: null,
};

const kycDukcapil = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_SELECTED_CITY: {
      return {
        ...state,
        selectedCity: action.payload,
      };
    }
    case ON_SELECTED_PLACE_BIRTH: {
      return {
        ...state,
        selectedPlaceBirth: action.payload,
      };
    }
    case ON_REQUEST_DUKCAPIL: {
      return {
        ...state,
        isRequestDukcapilResponse: null,
        isRequestDukcapil: true,
        isErrDukcapilError: null,
      };
    }
    case ON_REQUEST_DUKCAPIL_ERR: {
      return {
        ...state,
        isRequestDukcapilResponse: null,
        isRequestDukcapil: false,
        isErrDukcapilError: action.payload,
      };
    }
    case ON_REQUEST_DUKCAPIL_SUCCESS: {
      return {
        ...state,
        isRequestDukcapilResponse: action.payload,
        isRequestDukcapil: false,
        isErrDukcapilError: null,
      };
    }
    case ON_REQUEST_VERIFY_DUKCAPIL: {
      return {
        ...state,
        formVerifyDukcapil: null,
        isVerifyDukcapilLoading: true,
        isVerifyDukcapilFailure: null,
      };
    }
    case ON_REQUEST_VERIFY_DUKCAPIL_FAILURE: {
      return {
        ...state,
        formVerifyDukcapil: action.payload,
        isVerifyDukcapilLoading: false,
        isVerifyDukcapilFailure: action.payload,
      };
    }
    case ON_REQUEST_VERIFY_DUKCAPIL_SUCCESS: {
      return {
        ...state,
        formVerifyDukcapil: action.payload,
        isVerifyDukcapilLoading: false,
        isVerifyDukcapilFailure: null,
      };
    }
    case ON_SET_DOB: {
      return {
        ...state,
        dob: action.payload,
      };
    }
    case ON_COLLECTED_EXPERIENCE: {
      return {
        ...state,
        collectedExperience: action.payload,
      };
    }
    case ON_COLLECTED_OFFICE_INFORMATION: {
      return {
        ...state,
        collectedOfficeInformation: action.payload,
      };
    }
    case ON_COLLECTED_VIDEO_VERIFICATION: {
      return {
        ...state,
        rescVideo: action.payload,
      };
    }
    case ON_COLLECTED_ID_CARD: {
      return {
        ...state,
        idCard: action.payload,
      };
    }
    case ON_COLLECTED_SIGNATURE_IMG: {
      return {
        ...state,
        imgSignature: action.payload,
      };
    }
    case ON_COLLECTED_SIGN: {
      return {
        ...state,
        sign: action.payload,
      };
    }
    case ON_COLLECTED_BANK: {
      return {
        ...state,
        collectDataBank: action.payload,
      };
    }
    case ON_SELECTED_BANK: {
      return {
        ...state,
        selectedBank: action.payload,
      };
    }
    case GET_BANK_LIST: {
      return {
        ...state,
        bankData: action.payload,
      };
    }
    case COLLECT_DUKCAPIL_DATA: {
      return {
        ...state,
        collectData: action.payload,
      };
    }
    case NEXT_QUESTIONS: {
      return {
        ...state,
        activeScreen: action.payload,
      };
    }
    case NEXT_EDD_QUESTIONS: {
      return {
        ...state,
        activeScreenEdd: action.payload,
      };
    }    
    case FILL_AUTOMATE_FORM:
      return {
        ...state,
        manualForm: false,
        automateForm: true,
      };
    case FILL_MANUALLY_FORM:
      return {
        ...state,
        manualForm: true,
        automateForm: false,
      };
    case ON_RETRY_DUKCAPIL_FAILURE:
      return {
        ...state,
        dukcapilData: null,
        isLimitDukcapil: false,
        isFailureDukcapil: false,
      };
    case ON_REQUEST_DUKCAPIL_LIMIT:
      return {
        ...state,
        dukcapilData: null,
        isLimitDukcapil: true,
        isFailureDukcapil: false,
      };
    case ON_REQUEST_DUKCAPIL_FAILURE:
      return {
        ...state,
        dukcapilData: action.payload,
        isLimitDukcapil: false,
        isFailureDukcapil: true,
      };
    case ON_REQUEST_DUKCAPIL_COMPLETED:
      return {
        ...state,
        dukcapilData: action.payload,
        isLimitDukcapil: false,
        isFailureDukcapil: false,
      };
    case UPDATED_NIK_EDUCATION:
      return {
        ...state,
        religion: action.payload.religion,
        marital_status: action.payload.marital_status,
        education: action.payload.education,
        nik: action.payload.nik,
      };

    case ON_DO_REQUEST_CITY:
      return {
        ...state,
        cityLoader: true,
        cityData: null,
        cityError: null,
      };
    case ON_DO_REQUEST_CITY_FAILURE:
      return {
        ...state,
        cityLoader: false,
        cityData: null,
        cityError: action.payload,
      };
    case ON_DO_REQUEST_CITY_SUCCESS:
      return {
        ...state,
        cityLoader: false,
        cityData: action.payload,
        cityError: null,
      };

    case ON_REQUEST_VALIDATE_BANK_ACCOUNT:
      return {
        ...state,
        validateBankAcc: true,
        validateBankAccSuccess: null,
        validateBankAccError: null,
      };
    case ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        validateBankAcc: true,
        validateBankAccSuccess: action.payload,
        validateBankAccError: null,
      };
    case ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        validateBankAcc: true,
        validateBankAccSuccess: null,
        validateBankAccError: action.payload,
      };
    case ON_COLLECTED_EDD_INITIAL:
      return {
        ...state,
        collectedEddInitial: action.payload
      };
    case ON_COLLECTED_BENEFICIAL_OWNER:
      return {
        ...state,
        beneficialOwner: action.payload
      };
    default:
      return state;
  }
};

export default kycDukcapil;
